import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Tabs } from '@components/tabs';
import { ROUNDED_TAB_BLACK_VARIANT, TAB_TYPE_ROUNDED } from '@components/tabs/src/tabs.type';

import { CompanyTabsProps } from './company-tabs.type';

export const CompanyTabs = ({
  tabs,
  initialTabId,
  className = 'flex justify-center items-center pt-8',
}: CompanyTabsProps) => {
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState(initialTabId);

  useEffect(() => {
    setActiveTab(initialTabId);
  }, [initialTabId]);

  const handleTabChange = (activeTabId: string) => {
    setActiveTab(activeTabId);
    const tabSelected = tabs.find((tab) => tab.id === activeTabId);
    if (tabSelected?.href) {
      navigate(tabSelected.href);
    }
  };

  return (
    <Tabs
      tabs={tabs}
      activeTab={activeTab}
      onChange={handleTabChange}
      type={TAB_TYPE_ROUNDED}
      roundedVariant={ROUNDED_TAB_BLACK_VARIANT}
      paddingClasses='pl-4 pb-0'
      secondary
      className={className}
    />
  );
};
